console.log('js/customer-login.js -> v0.1.0');

// Force Google button width to 400px
(function() {
	function forceGoogleButtonWidth() {
		var googleButton = document.querySelector('.g_id_signin');
		if (googleButton) {
			googleButton.style.setProperty('width', '400px', 'important');
			googleButton.style.setProperty('min-width', '400px', 'important');
			googleButton.style.setProperty('max-width', '400px', 'important');
			
			// Target the container div
			var container = googleButton.querySelector('.S9gUrf-YoZ4jf');
			if (container) {
				container.style.setProperty('width', '400px', 'important');
				container.style.setProperty('min-width', '400px', 'important');
				container.style.setProperty('max-width', '400px', 'important');
			}
			
			// Target the iframe
			var iframe = googleButton.querySelector('iframe.L5Fo6c-PQbLGe');
			if (iframe) {
				iframe.style.setProperty('width', '400px', 'important');
				iframe.style.setProperty('min-width', '400px', 'important');
				iframe.style.setProperty('max-width', '400px', 'important');
			}
		}
	}
	
	// Run on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			setTimeout(forceGoogleButtonWidth, 100);
			setTimeout(forceGoogleButtonWidth, 500);
			setTimeout(forceGoogleButtonWidth, 1000);
		});
	} else {
		setTimeout(forceGoogleButtonWidth, 100);
		setTimeout(forceGoogleButtonWidth, 500);
		setTimeout(forceGoogleButtonWidth, 1000);
	}
	
	// Watch for Google button rendering with a simple observer (only on the button container, not the whole document)
	setTimeout(function() {
		var buttonContainer = document.querySelector('.button-container .g_id_signin');
		if (buttonContainer) {
			var observer = new MutationObserver(function() {
				forceGoogleButtonWidth();
			});
			observer.observe(buttonContainer, { 
				childList: true, 
				subtree: true
			});
		}
	}, 100);
})();

window.addEventListener('load', _ => {
	const cstmBtns = document.querySelectorAll('.cstm-btn[data-toggle="modal"]');
    if (!!cstmBtns.length && [7, 8, 13].includes(+siteid) && ![103, 109].includes(+pageType) ) {
		cstmBtns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				initLoginAPIsAsync().then().catch(e => console.error(e));
			});
		})
    } else {
		setTimeout(initLoginAPIs, 666);
	}
});

function initLoginAPIs() {
	(function(d, s, id) {
		var lang = "en_US";
		switch (selectedLanguage) {
			case "en":
				lang = "en_US";
				break;
			default:
				lang = selectedLanguage + "_" + selectedLanguage.toUpperCase();
				break;
		}

		var js, fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;
		js = d.createElement(s); js.id = id;
		js.src = 'https://connect.facebook.net/' + lang + '/sdk.js#xfbml=1&version=v2.12&appId='+ facebookAppId;
		fjs.parentNode.insertBefore(js, fjs);

		window.fbAsyncInit = function() {
			FB.Event.subscribe('xfbml.render', function() {
				$("#spinner .spinner").remove();
			});
		};

	})(document, 'script', 'facebook-jssdk');

	(function(w,d,s,g,js,fs) {
		g=w.gapi||(w.gapi={});g.analytics={q:[],ready:function(f){this.q.push(f);}};
		js=d.createElement(s);fs=d.getElementsByTagName(s)[0];
		js.src='https://apis.google.com/js/platform.js';
		fs.parentNode.insertBefore(js,fs);
		js.onload=function(){
			g.load('auth2', function() {
				var auth2 = gapi.auth2.init();
				var loginButtons = document.querySelectorAll('.js-google-auth-btn');

				for (var i = 0; i < loginButtons.length; i++) {
					auth2.attachClickHandler(loginButtons[i], {}, handleGoogleLogin);
				}

			});
		};
	})(window,document,'script');
}

var isCstmLginBtnsInitiated = false;

function initLoginAPIsAsync() {
    if (isCstmLginBtnsInitiated) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        (function(d, s, id) {
            var lang = "en_US";

            switch (selectedLanguage) {
                case "en":
                    lang = "en_US";
                    break;
                default:
                    lang = selectedLanguage + "_" + selectedLanguage.toUpperCase();
                    break;
            }

            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                isCstmLginBtnsInitiated = true;
                resolve();
                return;
            }

            js = d.createElement(s);
            js.id = id;
            js.src = `https://connect.facebook.net/${lang}/sdk.js#xfbml=1&version=v2.12&appId=${facebookAppId}`;

            js.onload = function() {
                isCstmLginBtnsInitiated = true;

                window.fbAsyncInit = function() {
                    FB.Event.subscribe('xfbml.render', function() {
                        $("#spinner .spinner").remove();
                    });
                };
                resolve();
            };

            fjs.parentNode.insertBefore(js, fjs);

        })(document, 'script', 'facebook-jssdk');

		(function(w,d,s,g,js,fs) {
			g=w.gapi||(w.gapi={});g.analytics={q:[],ready:function(f){this.q.push(f);}};
			js=d.createElement(s);fs=d.getElementsByTagName(s)[0];
			js.src='https://apis.google.com/js/platform.js';
			fs.parentNode.insertBefore(js,fs);
			js.onload=function(){
				g.load('auth2', function() {
					var auth2 = gapi.auth2.init();
					var loginButtons = document.querySelectorAll('.js-google-auth-btn');

					for (var i = 0; i < loginButtons.length; i++) {
						auth2.attachClickHandler(loginButtons[i], {}, handleGoogleLogin);
					}

				});
			};
		})(window,document,'script');
    });
}


function accountLogout() {
	gae('customer-login', 'logout');
	var loaderBodyParent = document.body;
	loaderBodyParent.classList.add("loading");

	$.ajax({
		type: "POST",
		url: "/account/auth/logout",
		success: function(response) {
			gae('customer-login', 'logout');
			if (response.ok)
				window.location.replace(response.redirect);
		},
		error: function(response) {
			loaderBodyParent.classList.remove("loading");
		}
	});
}

function handleFacebookLogin(facebookUser) {
	$(".login-form-wrapper .js-error").text("").removeClass('active');
	$(".signup-form-wrapper .js-error").text("").removeClass('active');
	$(".js-social-error").text("").removeClass('active');

	if (facebookUser.status == 'connected') {
		$.ajax({
			type: "POST",
			url: "/account/auth/facebook",
			data: {
				accessToken: facebookUser.authResponse.accessToken,
				userID: facebookUser.authResponse.userID,
				pageType: document.querySelector('#signup-page-type').value
			}
		}).done(function(response) {
			if(response.success) {
				if (response.newCustomer) {
					gae('customer-login', 'facebook-registration');
					marketing.trackSoftGoals(marketing.SoftGoals.AccountRegistration, 'facebook');
				}
				gae('customer-login', 'facebook-login');
				location.reload();
			}
			else {
				$(".js-social-error").text(response.errorMessage).addClass('active');
				$(".login-form-wrapper .js-error").text(response.errorMessage).addClass('active');
				$(".signup-form-wrapper .js-error").text(response.errorMessage).addClass('active');
			}
		}).fail(function(response) {
			$(".js-social-error").text(response.responseJSON.error.text).addClass('active');
			$(".login-form-wrapper .js-error").text(response.responseJSON.error.text).addClass('active');
			$(".signup-form-wrapper .js-error").text(response.responseJSON.error.text).addClass('active');
		});
	}
}

function handleGoogleLogin(googleUser) {
	$('.js-google-auth-btn .loading').show();
	$(".login-form-wrapper .js-error").text("").removeClass('active');
	$(".signup-form-wrapper .js-error").text("").removeClass('active');
	$(".js-social-error").text("").removeClass('active');

	$.ajax({
		method: "POST",
		url: "/account/auth/google",
		data: {
			token: googleUser.getAuthResponse().id_token,
			pageType: document.querySelector('#signup-page-type').value
		}
	}).done(function(response) {
		if(response.success) {
			if (response.newCustomer) {
				gae('customer-login', 'google-registration');
				marketing.trackSoftGoals(marketing.SoftGoals.AccountRegistration, 'google');
			}
			gae('customer-login', 'google-login');
			window.location.reload();
		}
		else {
			$('.js-google-auth-btn .loading').hide();
			$(".js-social-error").text(response.errorMessage).addClass('active');
			$(".login-form-wrapper .js-error").text(response.errorMessage).addClass('active');
			$(".signup-form-wrapper .js-error").text(response.errorMessage).addClass('active');
		}
	}).fail(function(response) {
		$('.js-google-auth-btn .loading').hide();
		$(".js-social-error").text(response.responseJSON.error.text).addClass('active');
		$(".login-form-wrapper .js-error").text(response.responseJSON.error.text).addClass('active');
		$(".signup-form-wrapper .js-error").text(response.responseJSON.error.text).addClass('active');
	});
}
